import { useState } from 'react'

export default function AutoPostingBadge({ confidenceScore, confidenceReasons }) {
  const [showTooltip, setShowTooltip] = useState(false)
  
  if (!confidenceScore) return null

  const tier = confidenceScore >= 80 ? 'high' : confidenceScore >= 60 ? 'medium' : 'low'
  
  const config = {
    high: {
      stars: '⭐⭐⭐',
      label: 'High Confidence',
      className: 'bg-green-100 text-green-800'
    },
    medium: {
      stars: '⭐⭐',
      label: 'Medium Confidence',
      className: 'bg-yellow-100 text-yellow-800'
    },
    low: {
      stars: '⭐',
      label: 'Low Confidence',
      className: 'bg-orange-100 text-orange-800'
    }
  }

  const { stars, className } = config[tier]

  // Parse confidence reasons (stored as JSON string)
  let reasons = []
  if (confidenceReasons) {
    try {
      reasons = typeof confidenceReasons === 'string' 
        ? JSON.parse(confidenceReasons) 
        : confidenceReasons
    } catch {
      // If parsing fails, treat as single reason
      reasons = [confidenceReasons]
    }
  }

  return (
    <div className="relative inline-block">
      <div 
        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium cursor-help ${className}`}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => setShowTooltip(!showTooltip)}
      >
        <span>🤖</span>
        <span>{stars} Auto-Detected ({confidenceScore}%)</span>
        {reasons.length > 0 && (
          <span className="opacity-60">ⓘ</span>
        )}
      </div>
      
      {/* Tooltip */}
      {showTooltip && reasons.length > 0 && (
        <div className="absolute z-50 left-0 mt-1 w-64 p-3 bg-white border border-gray-200 rounded-lg shadow-lg text-xs">
          <p className="font-semibold text-brand-charcoal mb-2">
            Why we think this is open ice:
          </p>
          <ul className="space-y-1 text-brand-slate">
            {reasons.slice(0, 5).map((reason, idx) => (
              <li key={idx} className="flex items-start gap-1.5">
                <span className="text-green-600 mt-0.5">✓</span>
                <span>{reason}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

